if (!customElements.get('vbb-victorias-recommendation')) {
    class VictoriasRecommendation extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      [
        'onIntersectVideoContainer',
        'onIntersectVideo',
        'onClickVideo',
        'onClickVideoMuteButton',
        'onChangeCheckbox'
      ].forEach((eventName) => this[eventName] = this[eventName].bind(this));

      this.productFormId = this.dataset.productFormId;
      this.videoContainerEl = this.querySelector('[data-video-container]');
      this.videoTemplateEl = this.querySelector('[data-video-template]');
      this.productForm = document.querySelector(`#${this.productFormId}`);
      this.productFormInputIdIndex = this.dataset.productFormInputIdIndex;
      this.variantId = this.dataset.variantId;
      this.variantPrice = this.dataset.variantPrice;
      this.checkboxEl = this.querySelector('[data-checkbox]');

      if (this.videoContainerEl) {
        this.videoContainerObserver = new IntersectionObserver(this.onIntersectVideoContainer);
        this.videoContainerObserver.observe(this.videoContainerEl);
      }

      if (this.checkboxEl) {
        this.checkboxEl.addEventListener('change', this.onChangeCheckbox);
      }
    }

    disconnectedCallback() {
      if (this.videoContainerEl) {
        this.videoContainerObserver.unobserve(this.videoContainerEl);
      }

      if (this.videoEl) {
        this.videoObserver.unobserve(this.videoEl);
        this.videoEl.removeEventListener('click', this.onClickVideo);

        if (this.videoMuteButtonEl) {
          this.videoMuteButtonEl.removeEventListener('click', this.onClickVideoMuteButton);
        }
      }

      if (this.checkboxEl) {
        this.checkboxEl.removeEventListener('change', this.onChangeCheckbox);
      }
    }

    onIntersectVideoContainer(entries) {
      let isIntersecting = !!entries.find((entry) => entry.isIntersecting);

      if (!isIntersecting) return;

      this.videoTemplateEl.outerHTML = this.videoTemplateEl.innerHTML;
      this.videoContainerObserver.unobserve(this.videoContainerEl);

      this.videoEl = this.querySelector('[data-video]');
      this.videoMuteButtonEl = this.querySelector('[data-video-mute-button]');

      if (this.videoEl) {
        this.videoObserver = new IntersectionObserver(this.onIntersectVideo);
        this.videoObserver.observe(this.videoEl);
        this.videoEl.addEventListener('click', this.onClickVideo);

        if (this.videoMuteButtonEl) {
          this.videoMuteButtonEl.addEventListener('click', this.onClickVideoMuteButton);
        }
      }
    }

    onIntersectVideo(entries) {
      const [entry] = entries;
      const isIntersecting = entry.isIntersecting;
      if (shouldAutoplayVideo()) {
        this.videoEl[isIntersecting ? 'play' : 'pause']();
      }
      // console.log(`Video ${isIntersecting ? 'started' : 'paused'} due to intersection observer.`);
    }

    onClickVideo() {
      this.videoEl[this.videoEl.paused ? 'play' : 'pause']();
    }

    onClickVideoMuteButton() {
      this.videoEl.muted = !this.videoEl.muted;
      this.videoContainerEl.classList[this.videoEl.muted ? 'add' : 'remove']('is-muted');
    }

    onChangeCheckbox() {
      if (this.checkboxEl.checked) {
        this.addProductFormInput();
      } else {
        this.removeProductFormInput();
      }

      if (!this.productForm || this.productFormId) {
        console.warn('Product form not found or productFormId is not set.');
        return;
      }

      this.productForm.dispatchEvent(new CustomEvent('victorias-recommendation:changed', {
        detail: {
          productFormId: this.productFormId
        },
        bubbles: true
      }));
    }

    addProductFormInput() {
      if(!this.productForm || !this.productFormInputIdIndex){
        console.warn('Product form or productFormInputIdIndex not set.');
        return;
      }
      let html = `
        <input
          type="hidden"
          name="items[${this.productFormInputIdIndex}][id]"
          value="${this.variantId}"
          data-victorias-recommendation-variant-id
          data-variant-price="${this.variantPrice}"
        >
      `;

      this.productForm.querySelector('form').insertAdjacentHTML('beforeend', html);
    }

    removeProductFormInput() {
      if (!this.productForm) {
        console.warn('Product form not found.');
        return;
      }
    let input = this.productForm.querySelector('form [data-victorias-recommendation-variant-id]');

      if (input) {
        input.remove();
      }
    }
  }

  customElements.define('vbb-victorias-recommendation', VictoriasRecommendation);
}
